module.exports = __webpack_public_path__ + "assets/img/arrow-left.987df39a.svg";